import { Injectable, inject } from '@angular/core';
import { FieldService } from '@core/jss-utils';

import { Hero } from '../models/hero.model';

@Injectable({
  providedIn: 'root',
})
export class HeroFieldService {
  readonly #fieldService = inject(FieldService);

  hasMultiColumnLayout(hero?: Partial<Hero>, hasWidget?: boolean): boolean {
    return hasWidget || !!hero?.mainImage;
  }

  showButtonGroup(hero?: Partial<Hero>): boolean {
    return this.#fieldService.showLinkFields(
      hero?.primaryButton,
      hero?.secondaryButton,
      { value: hero?.appStoreButton },
      { value: hero?.googlePlayButton }
    );
  }

  showCard(hero: Partial<Hero>, hasAsset: boolean, isEssent: boolean): boolean {
    return (
      this.#fieldService.showImageField(hero?.mainImage) && hasAsset && isEssent
    );
  }
}
